import http from '../config/http';
import routes from '../config/api_routes';

export const getActiveFaqs = () => http(true).get(routes.faqs.getAll);
export const getAllCategories = () => http(true).get(routes.faqs.getAllCategories);
export const getByCategory = (id) => http(true).get(routes.faqs.getByCategory.replace(':id', id));